import React from 'react';
import { Link } from 'react-router-dom';
import { LuBookOpen, LuPlus, LuSearch } from 'react-icons/lu';
import LearnNotebookCard from '../../pages/learn/LearnNotebookCard';

function NotebookGridSkeleton() {
  return (
    <div className="learn-nb-grid learn-nb-grid--books" aria-hidden>
      {[0, 1, 2].map((i) => (
        <div key={i} className="learn-nb-skeleton learn-nb-skeleton--book" />
      ))}
    </div>
  );
}

export default function LearnMyNotebooksPanel({
  loading,
  notebooks,
  filteredNotebooks,
  query,
  onQueryChange,
  stats,
  onCreateClick,
  showSearch,
}) {
  const total = notebooks.length;
  const shown = filteredNotebooks.length;

  return (
    <section
      id="learn-my-notebooks"
      className="library-read-panel learn-my-notebooks-panel"
      aria-labelledby="learn-my-notebooks-title"
    >
      <div className="library-read-unified-card">
        <div className="catalog-showcase learn-my-notebooks-showcase">
          <div className="catalog-showcase-hero catalog-showcase-hero--split">
            <div className="catalog-showcase-hero-top">
              <div className="catalog-showcase-hero-main">
                <span className="catalog-showcase-icon" aria-hidden>
                  <LuBookOpen />
                </span>
                <div className="catalog-showcase-copy">
                  <p className="catalog-showcase-eyebrow">Your Q&amp;A</p>
                  <h2 id="learn-my-notebooks-title" className="catalog-showcase-title">
                    Create &amp; manage Q&amp;A
                  </h2>
                </div>
              </div>
              {!loading && (
                <dl
                  className="learn-page-stats learn-page-stats--hero catalog-showcase-metrics catalog-showcase-metrics--right"
                  aria-live="polite"
                >
                  <div>
                    <dt>Yours</dt>
                    <dd>{stats.createdByYou}</dd>
                  </div>
                  <div>
                    <dt>With Q&amp;A</dt>
                    <dd>{stats.withQuestions}</dd>
                  </div>
                  <div>
                    <dt>Studying</dt>
                    <dd>{stats.inProgress}</dd>
                  </div>
                </dl>
              )}
            </div>
            <div className="catalog-showcase-lead-row">
              <p className="catalog-showcase-lead">
                Import PDFs, URLs, or pasted text into Q&amp;A you own. Open any set to edit cards, then practice from
                Study hub when you are ready.
              </p>
              <ol className="catalog-showcase-flow catalog-showcase-flow--inline" aria-label="How your Q&A works">
                <li><span>Create</span> Q&amp;A</li>
                <li><span>Import</span> sources</li>
                <li><span>Review</span> on Study hub</li>
              </ol>
            </div>
          </div>

          <div className="catalog-showcase-toolbar learn-my-notebooks-toolbar">
            {showSearch ? (
              <label className="catalog-showcase-search">
                <LuSearch className="catalog-showcase-search-icon" aria-hidden />
                <input
                  type="search"
                  className="library-read-search"
                  placeholder="Search your Q&A…"
                  value={query}
                  onChange={(e) => onQueryChange(e.target.value)}
                  aria-label="Search your Q&A"
                />
              </label>
            ) : (
              <span className="catalog-showcase-toolbar-meta">Q&amp;A you own in this hub</span>
            )}
            <button
              type="button"
              className="sh-block-link library-read-custom-btn learn-btn-with-icon"
              onClick={onCreateClick}
            >
              <LuPlus aria-hidden />
              Create Q&amp;A
            </button>
          </div>

          {loading && <NotebookGridSkeleton />}

          {!loading && total === 0 && (
            <div className="learn-my-notebooks-empty">
              <LuBookOpen className="library-read-catalog-empty-icon" aria-hidden />
              <p className="library-read-catalog-empty-title">No Q&amp;A yet</p>
              <p className="library-read-catalog-empty-text">
                Use Create Q&amp;A, then import a PDF, paste text, or add a URL on the Q&amp;A page.
              </p>
              <button
                type="button"
                className="library-read-catalog-empty-action"
                onClick={onCreateClick}
              >
                Create Q&amp;A
              </button>
            </div>
          )}

          {!loading && total > 0 && shown === 0 && (
            <div className="learn-my-notebooks-empty">
              <p className="library-read-catalog-empty-title">No Q&amp;A match</p>
              <p className="library-read-catalog-empty-text">Try a different search term.</p>
              {query.trim() ? (
                <button
                  type="button"
                  className="library-read-catalog-empty-action"
                  onClick={() => onQueryChange('')}
                >
                  Clear search
                </button>
              ) : null}
            </div>
          )}

          {!loading && shown > 0 && (
            <div className="learn-nb-grid learn-nb-grid--books learn-my-notebooks-grid">
              {filteredNotebooks.map((nb) => (
                <LearnNotebookCard key={nb.id} notebook={nb} layout="book" />
              ))}
            </div>
          )}

          {!loading && total > 0 && (
            <p className="catalog-showcase-footnote">
              {shown === total
                ? `${total} Q&A set${total === 1 ? '' : 's'} in your hub.`
                : `${shown} of ${total} shown.`}{' '}
              Reading happens in <Link to="/library">Library</Link>; reviews and due cards live on{' '}
              <Link to="/dashboard">Study hub</Link>.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
